<a class="notification-link" (click)="downloadFile()">{{
  'Analysis::ClickHereToDownloadNonFCRReport' | abpLocalization
}}</a>
